import { useState } from "react";

export default function ResourcesLessonsPage() {
  const [loading, setLoading] = useState(true);

  return (
    <main className="all-resources-page page">
      <div className="w-full h-[calc(100vh-100px)] relative">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
            <span className="loader"></span>
          </div>
        )}

        <iframe
          title="Resources with Lesson Plans"
          className="airtable-embed"
          src="https://airtable.com/embed/apprWesJGBmsmfsWx/shrphyA95OaW1g824"
          frameBorder="0"
          width="100%"
          height="100%"
          style={{ background: "transparent", border: "1px solid var(--color-border-subtle)" }}
          onLoad={() => setLoading(false)}
        />
      </div>
    </main>
  );
}
